import useScroll from "../../Hooks/useScroll";
import { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const PersonalCare = ({showIcon}) => {
  const [linkThreeHover, setLinkThreeHover] = useState(false);
  const [scrollPosition] = useScroll();

  return (
    <div
      onMouseEnter={() => {
        setLinkThreeHover(true);
        showIcon();
      }}
      onMouseLeave={() => setLinkThreeHover(false)}
      className={`transition-all ease-in-out duration-300 min-h-[50px] flex items-center ${
        scrollPosition > 80 ? "min-h-[65px]" : ""
      }`}
    >
      <p
        className={`mr-10 block font-bold cursor-pointer ${
          scrollPosition > 80
            ? "hover:text-accent text-secondary"
            : "text-secondary hover:text-accent"
        }`}
      >
        PERSONAL CARE
        <FontAwesomeIcon
          className="w-3 ms-2"
          icon={faChevronDown}
        ></FontAwesomeIcon>
      </p>
      
      <div
        className={`flex flex-col md:flex-row absolute top-10 bg-white w-fit h-[100vh] md:h-auto md:ml-[-250px] ${
          linkThreeHover ? "block text-start" : "hidden relative"
        } text-black `}
      >
        {/* ........BATH & SHOWER......... */}
        <div className="px-10 py-10 pt-16 md:py-16">
          <p className="mb-6 text-black text-opacity-70">BATH & SHOWER</p>
          <Link
            to="/product-category/scrubs"
            className=" hover:text-accent block"
          >
            Scrubs
          </Link>
          <Link
            to="/product-category/shower gel"
            className=" hover:text-accent block"
          >
            Shower Gel
          </Link>
          <Link
            to="/product-category/body wash"
            className=" hover:text-accent block"
          >
            Body Wash
          </Link>

        </div>
        {/* ........Body......... */}
        <div className="px-10 py-10 md:py-16">
          <p className="mb-6 text-black text-opacity-70">BODY</p>
          <Link
            to={`/product-category/sunscream`}
            className=" hover:text-accent block"
          >
            Sunscream
          </Link>

          <Link
            to={`/product-category/lotion`}
            className=" hover:text-accent block"
          >
            Lotion
          </Link>
          <Link
            to={`/product-category/cream`}
            className=" hover:text-accent block"
          >
            Creams
          </Link>
        </div>
        {/* ........Fragrances........ */}
        <div className="px-10 py-10 md:py-16 pb-[120px]">
          <p className="mb-6 text-black text-opacity-70">FRAGRANCES</p>
          <Link
            to={`/product-category/perfume`}
            className=" hover:text-accent block"
          >
            Perfume
          </Link>
          <Link
            to={`/product-category/body spray`}
            className=" hover:text-accent block"
          >
            Body Spray
          </Link>
          <Link
            to={`/product-category/body mist`}
            className=" hover:text-accent block"
          >
            Body Mist
          </Link>
          <Link
            to={`/product-category/deodorant`}
            className=" hover:text-accent block"
          >
            Deodorant
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PersonalCare;
